"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProvider = exports.mockProvider = exports.createProvider = void 0;
var is_promise_1 = __importDefault(require("is-promise"));
var react_1 = __importStar(require("react"));
var use_promise_1 = require("./use-promise");
function isContextFactory(value) {
    return typeof value === 'function';
}
/**
 * Create a new provider that can be access throughout the application. If a promise is returned we need to wrap
 * it in another component so that when we throw the promise the component state isn't lost.
 */
function createProvider(getContextValue, providerOptions) {
    if (providerOptions === void 0) { providerOptions = {}; }
    var name = providerOptions.name, context = providerOptions.context;
    var Context = context !== null && context !== void 0 ? context : react_1.default.createContext(null);
    var Provider = function (props) {
        var children = props.children;
        var value = isContextFactory(getContextValue) ? getContextValue(props) : getContextValue;
        if ((0, is_promise_1.default)(value)) {
            return (react_1.default.createElement(use_promise_1.ResolvePromise, { promise: value }, function (value) { return react_1.default.createElement(Context.Provider, { value: value }, children); }));
        }
        return react_1.default.createElement(Context.Provider, { value: value }, children);
    };
    Provider.displayName = name !== null && name !== void 0 ? name : 'Provider';
    Provider.context = Context;
    return Provider;
}
exports.createProvider = createProvider;
/**
 * Mock a provider and set a dummy value on the context.
 */
function mockProvider(provider, value) {
    if (!provider.context) {
        throw new Error("Context value not set on provider: ".concat(provider.displayName));
    }
    var Provider = provider.context.Provider;
    return function (props) {
        var children = props.children;
        return react_1.default.createElement(Provider, { value: value }, children);
    };
}
exports.mockProvider = mockProvider;
/**
 * Access the context value of a provider.
 */
function useProvider(provider) {
    if (!provider.context) {
        throw new Error("Context value not set on provider: ".concat(provider.displayName, "."));
    }
    var value = (0, react_1.useContext)(provider.context);
    if (!value) {
        throw new Error('Provider not added to the root of the application.');
    }
    return value;
}
exports.useProvider = useProvider;
